import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/priceMatrixActions';

// Falls back to the existing value, which is what keeps this null on the non-200 failure path —
// that action carries only a message.
const searchInformationSlice = createSlice({
  name: 'searchInformation',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (state, action) => action.payload.searchInformation || state)
      .addCase(initFailed, (state, action) => action.payload.searchInformation || state);
  },
});

export default searchInformationSlice.reducer;
